import { Calc } from 'src/app/shared/utils/calc';
import { Health } from '../../../devices/components/devices.models';
import { HealthFilter } from '../../health-api.types';
import { HealthStatistic } from '../../health-monitor.types';

const calculateAllDevicesHealthTotalCount = (devices: HealthFilter[]): number => {
  const device = devices.reduce((count, device) => {
    return (
      count +
      device.deviceStatusValues.reduce((acc, currentValue) => {
        return acc + currentValue.totalCount;
      }, 0)
    );
  }, 0);
  return device;
};

const tunePercentage = (healthStatistic: HealthStatistic, maxPercent: number, percentageSum: number): void => {
  const minDeviation = 1;
  const maxDeviation = 2;

  for (const key in healthStatistic) {
    const device = healthStatistic[key as Health];

    if (device.percent === maxPercent) {
      switch (percentageSum) {
        case 101:
          device.percent = Number(device.percent) - minDeviation;
          break;
        case 99:
          device.percent = Number(device.percent) + minDeviation;
          break;
        case 102:
          device.percent = Number(device.percent) - maxDeviation;
          break;
        case 98:
          device.percent = Number(device.percent) + maxDeviation;
          break;
      }
    }
  }
};

const updateHealthStatisticWithPercents = (healthStatistic: HealthStatistic, totalCount: number): HealthStatistic => {
  if (!totalCount) return healthStatistic;

  const fullPercent = 100;
  const percentages: number[] = [];

  for (const key in healthStatistic) {
    const currentCount = healthStatistic[key as Health].count;
    const integer = totalCount ? Math.round(Calc.percent(currentCount, totalCount) as number) : 0;
    percentages.push(integer);
    healthStatistic[key as Health].percent = healthStatistic[key as Health].count ? integer : 0;
  }

  const percentageSum = percentages.reduce((acc, value) => acc + value);
  const maxValue = Math.max(...percentages);

  if (percentageSum === fullPercent) {
    return healthStatistic;
  } else {
    tunePercentage(healthStatistic, maxValue, percentageSum);

    return healthStatistic;
  }
};

const updateHealthStatisticWithCount = (healthStatistic: HealthStatistic, devices: HealthFilter[]): HealthStatistic => {
  devices.forEach(device => {
    device.deviceStatusValues.forEach(status => {
      healthStatistic[status.deviceStatusValue as Health].count += status.totalCount;
    });
  });

  return healthStatistic;
};

export const createHealthStatistic = (devices: HealthFilter[]): HealthStatistic => {
  const healthStatistic: HealthStatistic = {
    Good: { percent: 0, count: 0 },
    Moderate: { percent: 0, count: 0 },
    Bad: { percent: 0, count: 0 },
    New: { percent: 0, count: 0 },
    Unknown: { percent: 0, count: 0 }
  };

  const healthTotalCount = calculateAllDevicesHealthTotalCount(devices);

  return updateHealthStatisticWithPercents(updateHealthStatisticWithCount(healthStatistic, devices), healthTotalCount);
};
